jQuery(function ($) {

  const $header = $('header.shopify-section--header');
  const line = $header.outerHeight() + $header.position().top;

  $(window).on({
    'scroll': function () {
      const scroll = $(window).scrollTop();

      if (scroll > line) {
        if (!$header.hasClass('fixed')) {
          $header.addClass('fixed');
        }
      } else {
        if ($header.hasClass('fixed')) {
          $header.removeClass('fixed');
        }
      }
    }
  });

});

jQuery(function ($) {
  const getMaxLength = (str, max) => {
    let a = 0;
    let count = 0
    for (let i = 0, len = str.length; i < len; i++) {
      let c = str.charCodeAt(i)

      if (!str[i].match(/\r?\n/g)) { // 改行コード判定
        if (c >= 0x0 && c <= 0x7f) { // 全角半角判定
          count += 0.5
        } else {
          count += 1
        }
      }
      a++;
      if (Math.ceil(count) >= max) {
        break;
      }
    }
    return a
  };

  const change_excerpt = () => {
    const $blog_excerpt = $('.blog-post-card__excerpt');

    if ($blog_excerpt.length) {
      $blog_excerpt.each((i, row) => {
        if (!$(row).data('origin')) {
          $(row).data('origin', $(row).text());
        }

        const max_count = Math.floor($(row).width() / 14.5) * 2;
        const count = getMaxLength($(row).data('origin'), max_count);

        let excerpt_text = $(row).data('origin');
        if (excerpt_text.length > count) {
          excerpt_text = $(row).data('origin').slice(0, count) + '...';
        }
        $(row).html(excerpt_text);
      });
    }
  };

  if ($('body').hasClass('template-index')) {
    $(window).on({
      'resize load': function () {
        change_excerpt();
      }
    });
  }
});

/*
jQuery(function ($) {
  const $a = $('<a href="https://hiro-taka.com/pages/look-book" class="block h5">Lookbooks</a>')
  $('.header__primary-nav-item[data-title="Style Guide"]').attr('data-title', 'Lookbooks').html($a);
});
*/
